import { ViewModel,View, ObservableArray } from "binder"
import { Moment } from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PersonSearchViewModel } from "../personSearch-viewModel";
import { IGateway, IReceiveInfoProvider } from "./gateways/IGateway";
import  { CreateReceivableView } from "./createReceivable-view"
import { CashGatewayViewModel } from "./gateways/cashGateway/cashGateway-viewModel";
import { DebitGatewayViewModel } from "./gateways/debitGateway/debitGateway-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import moment from "moment";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";

export class CreateReceivableViewModel extends WindowViewModel implements IReceiveInfoProvider{
    public getTitle(): string {
        return 'ثبت دریافت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personSelector = new PersonSearchViewModel(this);
        this.personSelector.onSelectionChanged = p=>{
            this.selectedPersonName = p.name;
            this.selectedPersonCode = p.code; 
        }
        this.gateways = ObservableArray.create<IGateway>();
        this.gateways.push(...[
            new CashGatewayViewModel(this),
            new DebitGatewayViewModel(this),
            // new IbanGatewayViewModel(this),
            // new AccountGatewayViewModel(this),
            // new ChequeGatewayViewModel(this)
        ]);
        this.time = moment.utc(moment.now());
        this.attachments = new AttachmentListSelectorViewModel(this);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new CreateReceivableView();
    }
    public getTypeId(): string {
        return "VM-327E423B-81ED-488F-9A6D-98CF7321B417"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personSelector(v: PersonSearchViewModel) { this._personSelector = v; } public get personSelector(): PersonSearchViewModel { return this._personSelector;} private _personSelector: PersonSearchViewModel;
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways;} private _gateways: ObservableArray<IGateway>;
    public set selectedPersonName(v: string) { this._selectedPersonName = v; } public get selectedPersonName(): string { return this._selectedPersonName;} private _selectedPersonName: string;
    public set selectedPersonCode(v: string) { this._selectedPersonCode = v; } public get selectedPersonCode(): string { return this._selectedPersonCode;} private _selectedPersonCode: string;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
    
    public set selectedGateway(v: IGateway) { 
        v?.initialLoad();
        this._selectedGateway = v; 
    } public get selectedGateway(): IGateway { return this._selectedGateway;} private _selectedGateway: IGateway;
    
    async create(){
        let validationResult = this.validateInformation();
        if (validationResult.length != 0){
            await this.messageBoxConfirmWarning(validationResult.join('\r\n'),"خطا")
        }
        else{
            try {
                this.isLoading = true;
                let result = await this.selectedGateway.save(this);
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess(`سند دریافت و پرداخت به شماره ${result.ArapCode} و سند حسابداری با شماره ${result.AccountingCode} ثبت شد.`,'ثبت دریافت');
                }
                this.close();
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    validateInformation(): string[] {
        let result: string[] = []
        if (this.personSelector.selectedItem == null) result.push('پرداخت کننده انتخاب نشده است.');
        if (this.personSelector.selectedItem != null && stringIsNullOrEmpty(this.selectedPersonName)) result.push('نام پرداخت کننده به درستی مشخص نشده است.');
        // if (this.personSelector.selectedItem != null && stringIsNullOrEmpty(this.selectedPersonCode)) result.push('کد پرداخت کننده به درستی مشخص نشده است.');
        if (this.amount == null) result.push('مبلغ وارد نشده است.');
        if (this.time == null) result.push('تاریخ و زمان پرداخت مشخص نشده است.');
        // if (this.accountSelector.accountSelector.selectedAccount == null) result.push('حساب انتخاب نشده است.');
        // if (this.accountSelector.details.map(x=>x.valueSelector.selectedItem==null).filter(x=>x==true).length>0) result.push('مقادیر تفضیل تنظیم نشده اند.');
        if (this.selectedGateway == null) result.push('روش دریافت مشخص نشده است.');
        if (this.selectedGateway != null) result.push(...this.selectedGateway.validate());
        return result;
    }

    getBaseReceivableInfoDto(): { PayerPersonId: string; Amount: number; ReasonType: number; Time: Moment; Title: string; Description: string; Attachments:{Id:string,Name:string,Data:string}[] } {
        return {
            PayerPersonId : this.personSelector.selectedItem.id,
            Amount : this.amount,
            Title : '',
            Description : this.comment,
            ReasonType : 0,
            Time : this.time,
            Attachments : this.attachments.getAttachments().map(q=>{
                return {
                    Id :q.id,
                    Name:q.name,
                    Data:q.content
                };
            })
        };
    }

}


